import { faFileAlt } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as ticketActions from "../../../modules/ticket/action";
import "../../../style";
import customPrint from "../../../utils/CustomPrint";
import DownLoadAsCSV from "../../Common/DownloadAsCSV";
import EmailModal from "../../Common/EmailModal";
import CreateTable from "../../CreateTable";

class ReportsGenerateTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      headerRows: {
        loadDate: "Load Date",
        contract: "Contract Number",
        // ticketNumber: "Ticket Number",
        origin: "Origin",
        // originType: "Origin Type",
        loadNumber: "Load No Indicator",
        commodity: "Commodity",
        commodityVariety: "Commodity Variety",
        counterpart: "Counterpart",
        destination: "Destination",
        truckline: "Truckline",
        // driverName: "Driver Name",
        // estimatedHomeScaleShrinkBushels: "Est. Home Scale Shunk Bushels",
        // fieldEstimatedLoadBushels: "Field Estimated Load Bushels",
        // fieldEstimatedLoadWeight: "Field Estimated Load Weight",
        // fieldsEstimatedMoisture: "Field Estimated Moisture",
        // homeScaleEstimatedMoisture: "Home Scale Estimated Moisture",
        // loadCost: "Load Cost",
        // status: "Reconciliation Status",
        // shrinkMultiplier: "Shrink Multiplier",
        // trailerNumber: "Trailer Number",
        // truckNumber: "Truck Number"
      },
      headerRowsCSV: {
        loadDate: "Load Date",
        contract: "Contract Number",
        ticketNumber: "Ticket Number",
        origin: "Origin",
        originType: "Origin Type",
        loadNumber: "Load No Indicator",
        commodity: "Commodity",
        commodityVariety: "Commodity Variety",
        counterpart: "Counterpart",
        destination: "Destination",
        estimatedHomeScaleShrinkBushels: "Est. Home Scale Shunk Bushels",
        fieldEstimatedLoadBushels: "Field Estimated Load Bushels",
        fieldEstimatedLoadWeight: "Field Estimated Load Weight",
        fieldsEstimatedMoisture: "Field Estimated Moisture",
        homeScaleEstimatedMoisture: "Home Scale Estimated Moisture",
        loadCost: "Load Cost",
        shrinkMultiplier: "Field Shrink Multiplier",
        status: "Reconciliation Status",
        receivedNetBushels: "Net Shrunk Payload Bushels",
        payloadTicketNo:"Payload Ticket No.",
        netWeightLbs:"Net Weight(lbs)",
        moisturePer:"Moisture %",
        reconciliationShrinkMultiplier: "Reconciliation Shrink Multiplier",
        payloadNetDestShrunkBushels:"Payload Net Destination Shrunk Bushels",
        truckline: "Truckline",
        driverName: "Driver Name",
        trailerNumber: "Trailer Number",
        truckNumber: "Truck Number",
        scaleTicketNumber:"Scale Ticket Number",
        billOfLading:"Bill of Lading",
        comments:"Notes"
      },
      order: "desc",
      orderBy: "loadDate",
      fetchingSubFarmId: false,
      dataRows: [],
      dataRowsCSV: [],
      showEmailModal: false
    };
  }
  componentWillMount() {
    const { rowData } = this.props;
    this.craeteRowData(rowData);
    this.createRowsCSV(rowData);
  }

  componentWillReceiveProps(nextProps) {}

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };
  craeteRowData = rowData => {
    console.log(rowData);
    let data =
      rowData &&
      Object.keys(rowData).map(value => {
        let CurrentRow = rowData[value];
        let obj = [];
        var date = new Date(CurrentRow.loadDate);
        obj["loadDate"] = CurrentRow.loadDate
          ? moment(date).format("lll")
          : "NIL";
        obj["contract"] =
          CurrentRow.primaryContractNumber &&
          CurrentRow.primaryContractNumber.contractNumber;
        // obj["ticketNumber"] = CurrentRow.ticketNumber ? CurrentRow.ticketNumber : "-";
        obj["origin"] =
          CurrentRow.primarySource &&
          CurrentRow.originType &&
          `${CurrentRow.primarySource.name} (${CurrentRow.originType.type})`;
        // obj["originType"] = CurrentRow.originType && CurrentRow.originType.type;
        obj["loadNumber"] = CurrentRow.loadNumber && CurrentRow.loadNumber;
        obj["commodity"] = CurrentRow.commodity && CurrentRow.commodity.name;
        obj["commodityVariety"] =
          CurrentRow.commodityVariety && CurrentRow.commodityVariety.variety;
        obj["counterpart"] =
          CurrentRow.counterpart && CurrentRow.counterpart.name;
        obj["destination"] =
          CurrentRow.destination && CurrentRow.destination.name;
        obj["truckline"] =
          CurrentRow.trucklineEntity && CurrentRow.trucklineEntity.name;
        // obj["driverName"] = CurrentRow.driverName && CurrentRow.driverName;
        // obj["estimatedHomeScaleShrinkBushels"] = CurrentRow.estimatedHomeScaleShrinkBushels && CurrentRow.estimatedHomeScaleShrinkBushels;
        // obj["fieldEstimatedLoadBushels"] = CurrentRow.fieldEstimatedLoadBushels && CurrentRow.fieldEstimatedLoadBushels;
        // obj["fieldEstimatedLoadWeight"] = CurrentRow.fieldEstimatedLoadWeight && CurrentRow.fieldEstimatedLoadWeight;
        // obj["fieldsEstimatedMoisture"] = CurrentRow.fieldsEstimatedMoisture && CurrentRow.fieldsEstimatedMoisture;
        // obj["homeScaleEstimatedMoisture"] = CurrentRow.homeScaleEstimatedMoisture && CurrentRow.homeScaleEstimatedMoisture;
        // obj["loadCost"] = CurrentRow.loadCost && CurrentRow.loadCost;
        // obj["status"] = CurrentRow.status && CurrentRow.status.name;
        // obj["shrinkMultiplier"] = CurrentRow.shrinkMultiplier && CurrentRow.shrinkMultiplier;
        // obj["trailerNumber"] = CurrentRow.trailerNumber && CurrentRow.trailerNumber;
        // obj["truckNumber"] = CurrentRow.truckNumber && CurrentRow.truckNumber;
        obj["disabled"] = CurrentRow.disable ? CurrentRow.disable : false;
        
        return obj;
      });
    // return []
    this.setState(
      {
        dataRows: data
      },
      () => {
        console.log(this.state.dataRows);
      }
    );
  };

  createRowsCSV = rowData => {
    console.log('csv',rowData);
    let data =
      rowData &&
      Object.keys(rowData).map(value => {
        let CurrentRow = rowData[value];
        let obj = [];
        var date = new Date(CurrentRow.loadDate);
        obj["loadDate"] = CurrentRow.loadDate
          ? moment(date).format("lll")
          : "NIL";
        obj["billOfLading"] = CurrentRow.billOfLading
          ? CurrentRow.billOfLading
          : ""; 
        obj["scaleTicketNumber"] = CurrentRow.scaleTicketNumber
          ? CurrentRow.scaleTicketNumber
          : ""; 
        obj["comments"] = CurrentRow.comments
          ? CurrentRow.comments
          : ""; 
        obj["contract"] =
          CurrentRow.primaryContractNumber &&
          CurrentRow.primaryContractNumber.contractNumber;
        obj["ticketNumber"] = CurrentRow.ticketNumber
          ? CurrentRow.ticketNumber
          : "NIL";
        obj["origin"] =
          CurrentRow.primarySource &&
          CurrentRow.originType &&
          `${CurrentRow.primarySource.name} (${CurrentRow.originType.type})`;
        obj["originType"] = CurrentRow.originType && CurrentRow.originType.type;
        obj["loadNumber"] = CurrentRow.loadNumber && CurrentRow.loadNumber;
        obj["commodity"] = CurrentRow.commodity && CurrentRow.commodity.name;
        obj["commodityVariety"] =
          CurrentRow.commodityVariety && CurrentRow.commodityVariety.variety;
        obj["counterpart"] =
          CurrentRow.counterpart && CurrentRow.counterpart.name;
        obj["destination"] =
          CurrentRow.destination && CurrentRow.destination.name;
        obj["truckline"] =
          CurrentRow.trucklineEntity && CurrentRow.trucklineEntity.name;
        obj["driverName"] = CurrentRow.driverName && CurrentRow.driverName;
        obj["estimatedHomeScaleShrinkBushels"] =
          CurrentRow.estimatedHomeScaleShrinkBushels &&
          CurrentRow.estimatedHomeScaleShrinkBushels;
        obj["fieldEstimatedLoadBushels"] =
          CurrentRow.fieldEstimatedLoadBushels &&
          CurrentRow.fieldEstimatedLoadBushels;
        obj["fieldEstimatedLoadWeight"] =
          CurrentRow.fieldEstimatedLoadWeight &&
          CurrentRow.fieldEstimatedLoadWeight;
        obj["fieldsEstimatedMoisture"] =
          CurrentRow.fieldsEstimatedMoisture &&
          CurrentRow.fieldsEstimatedMoisture;
        obj["homeScaleEstimatedMoisture"] =
          CurrentRow.homeScaleEstimatedMoisture &&
          CurrentRow.homeScaleEstimatedMoisture;
        obj["loadCost"] = CurrentRow.loadCost && CurrentRow.loadCost;
        obj["status"] = CurrentRow.status && CurrentRow.status.name;
        obj["receivedNetBushels"] =
          CurrentRow.reconciliation &&
          CurrentRow.reconciliation.receivedNetBushels;
        obj["shrinkMultiplier"] =
          CurrentRow.shrinkMultiplier && CurrentRow.shrinkMultiplier;
        obj["trailerNumber"] =
          CurrentRow.trailerNumber && CurrentRow.trailerNumber;
        obj["truckNumber"] = CurrentRow.truckNumber && CurrentRow.truckNumber;
        obj["disabled"] = CurrentRow.disable ? CurrentRow.disable : false;
        obj["payloadTicketNo"] =
        CurrentRow.reconciliation && CurrentRow.reconciliation.payloadTicketNumber && CurrentRow.reconciliation.payloadTicketNumber
        obj["netWeightLbs"] =
        CurrentRow.reconciliation && CurrentRow.reconciliation.fieldReceivedNetLoadWeight && CurrentRow.reconciliation.fieldReceivedNetLoadWeight
        obj["moisturePer"] =
        CurrentRow.reconciliation && CurrentRow.reconciliation.fieldsReceivedMoisture && CurrentRow.reconciliation.fieldsReceivedMoisture
        obj["payloadNetDestShrunkBushels"] =
        CurrentRow && CurrentRow.recievedPayloadNetDestinationShrunkBushels && CurrentRow.recievedPayloadNetDestinationShrunkBushels
        obj["reconciliationShrinkMultiplier"] =
        CurrentRow && CurrentRow.shrinkReconciliation && CurrentRow.shrinkReconciliation
        return obj;
      });
    // return []
    this.setState(
      {
        dataRowsCSV: data
      },
      () => {
        console.log(this.state.dataRows);
      }
    );
  };

  deleteRow = id => {
    this.props.actions.deleteTicket(id);
  };

  handleShare = e => {
    window.open("mailto:xyz@abc.com");
    e.preventDefault();
    this.setState({
      // showEmailModal : true
    });
  };
  handlePrint = e => {
    e.preventDefault();
    customPrint(document.querySelector(".masterTable"));
  };

  render() {
    const {
      fetchingComplete,
      order,
      orderBy,
      dataRows,
      headerRows,
      dataRowsCSV,
      headerRowsCSV
    } = this.state;
    const { rowData } = this.props;
    return (
      <div>
        <hr />
        <div className="tableProprties">
          {/* <Link to="#"  onClick={this.handleShare}>
          <FontAwesomeIcon icon={faShareAlt} />
            <span>Share Report</span>
        </Link> */}

          <DownLoadAsCSV dataRows={dataRowsCSV} headerRows={headerRowsCSV} />

          <Link to="#" onClick={this.handlePrint}>
            <FontAwesomeIcon icon={faFileAlt} />
            <span>Print Report</span>
          </Link>
          {
            // <Link to="#" ></Link>
          }
        </div>
        <CreateTable
          orderBy={orderBy}
          order={order}
          onRequestSort={this.handleRequestSort}
          headerRows={this.state.headerRows}
          rowData={dataRows}
          delete={this.deleteRow}
          isMenuRequired={false}
        />
        {this.state.showEmailModal ? <EmailModal /> : null}
      </div>
    );
  }
}
function mapStateToProps(state, props) {
  return {
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    SubFarmId: state.FarmManagementReducer.SubFarmId
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...ticketActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportsGenerateTable);



// WEBPACK FOOTER //
// ./src/components/private/Reports/ReportsGenerateTable.js